(function (can) {

    can.fixture.on = false;

    can.fixture.delay = 500;

    can.fixture("POST /api/p2p/widget/info", function () {
        return {
            "response": {
                "currency": "UAH",
                "custom_css": "",
                "client_fee_percent": 0.01,
                "client_fee_fix": 5.0,
                "min_amount": 10.0,
                "max_amount": 10.0,
                "validate_expdate": false,
                "template": "fondy"
            }
        }
    });


    can.fixture("POST /api/p2p/ajax/check", function () {
        return {
            "response": {
                "status": true
            }
        }
    });

    can.fixture("POST /api/p2p/widget/debit/form", function () {
        return {
            "response": {
                "sender": [],
                "receiver": []
            }
        }
    });

    can.fixture("POST /api/p2p/widget/credit/form", function () {
        return {
            "response": {
                "sender": [],
                "receiver": []
            }
        }
    });

    can.fixture("POST /api/p2p/widget/fee", function () {
        return {
            "response": {
                "fee": Math.abs(Math.random()).toFixed(2)
            }
        }
    });

    can.fixture("POST /api/p2p/ajax/lookup", function (xhr) {
        return {
            "response": {
                "action": "redirect",
                "url": "?widget_id=2&order_id=1"
            }
        }
    });

    can.fixture("POST /api/p2p/widget/transfer", function (xhr) {
        return {
            "response": {
                "action": "verification",
                "order_id": 3425236,
                "type": "code"
            }
        };
    });

    can.fixture("POST /api/p2p/widget/receive", function (xhr) {
        return {
            "response": {
                "action": "redirect",
                "url": "?widget_id=2&order_id=3"
            }
        };
    });

    can.fixture("POST /api/p2p/widget/status", function (xhr) {
        return {
            "response": {
                "status": "success", // pending success failure
                "amount": "5000",
                "currency": "UAH",
                "receiver": "step*******yi.com"
            }
        }
    });

})(window['can']);



function regExp(name) {
    return new RegExp('(^| )' + name + '( |$)');
}

function forEach(list, fn, scope) {
    for (var i = 0; i < list.length; i++) {
        fn.call(scope,list[i]);
    }
}


function ClassList(element) {
    this.element = element;
}

ClassList.prototype = {
    add: function () {
        forEach(arguments, function (name) {
            if (!this.contains(name)) {
                this.element.className += ' ' + name;
            }
        }, this);
    },
    remove: function () {
        forEach(arguments, function (name) {
            this.element.className =
                this.element.className.replace(regExp(name), '');
        }, this);
    },
    toggle: function (name) {
        return this.contains(name)
            ? (this.remove(name), false) : (this.add(name), true);
    },
    contains: function (name) {
        return regExp(name).test(this.element.className);
    },
    replace: function (oldName, newName) {
        this.remove(oldName);
        this.add(newName);
    }
};
if (!('classList' in Element.prototype)) {
    Object.defineProperty(Element.prototype, 'classList', {
        get: function () {
            return new ClassList(this);
        }
    });
}
if (window.DOMTokenList && DOMTokenList.prototype.replace == null) {
    DOMTokenList.prototype.replace = ClassList.prototype.replace;
}


if (!Array.prototype.filter) {
    Array.prototype.filter = function (fun/*, thisArg*/) {
        'use strict';
        if (this === void 0 || this === null) {
            throw new TypeError();
        }
        var t = Object(this);
        var len = t.length >>> 0;
        if (typeof fun !== 'function') {
            throw new TypeError();
        }
        var res = [];
        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
        for (var i = 0; i < len; i++) {
            if (i in t) {
                var val = t[i];
                if (fun.call(thisArg, val, i, t)) {
                    res.push(val);
                }
            }
        }
        return res;
    };
}
if (!String.prototype.trim) {
    (function () {
        String.prototype.trim = function () {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };
    })();
}

if (!Array.prototype.indexOf) {
    (function () {
        Array.prototype.indexOf = function (item) {
            for (var i = 0, l = this.length; i < l; i++) {
                if (i in this && this[i] === item) return i;
            }
            return -1;
        };
    })();
}

var defaultFormat = /(\d{1,4})/g;

var CARD_TYPES = [
    {
        type: 'prostir',
        patterns: [9804,9888,9000,6262],
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    },
    {
        type: 'elo',
        patterns: [401178, 401179, 431274, 438935, 451416, 457393, 457631, 457632, 504175, 506699, 5067, 509, 627780, 636297, 636368, 650, 6516, 6550],
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'maestro',
        patterns: [5018, 502, 503, 506, 56, 58, 639, 6220, 67],
        format: defaultFormat,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'forbrugsforeningen',
        patterns: [600],
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'dankort',
        patterns: [5019],
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'visa',
        patterns: [4],
        format: defaultFormat,
        length: [13, 16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'mastercard',
        patterns: [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27],
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'amex',
        patterns: [34, 37],
        format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        length: [15],
        cvcLength: [3, 4],
        luhn: true
    }, {
        type: 'dinersclub',
        patterns: [30, 36, 38, 39],
        format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
        length: [14],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'discover',
        patterns: [60, 64, 65, 622],
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }, {
        type: 'unionpay',
        patterns: [62, 88],
        format: defaultFormat,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        luhn: false
    }, {
        type: 'jcb',
        patterns: [35],
        format: defaultFormat,
        length: [16],
        cvcLength: [3],
        luhn: true
    }
];

function eventTimeout(fn) {
    return setTimeout((function (cx) {
        return function () {
            return fn.apply(cx, arguments);
        }
    })(this));
}

function restrictNumeric(ev) {
    if (ev.metaKey || ev.ctrlKey)
        return true;
    if (ev.which === 32)
        return false;
    if (ev.which === 0)
        return true;
    if (ev.which < 33)
        return true;
    return !!/[\d\s]/.test(String.fromCharCode(ev.which));
}

function cardFromNumber(num) {
    var card, p, pattern, _i, _j, _len, _len1, _ref;
    num = (num + '').replace(/\D/g, '');
    for (_i = 0, _len = CARD_TYPES.length; _i < _len; _i++) {
        card = CARD_TYPES[_i];
        _ref = card.patterns;
        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
            pattern = _ref[_j];
            p = pattern + '';
            if (num.substr(0, p.length) === p) {
                return card;
            }
        }
    }
}

function cardFromType(type) {
    var card, _i, _len;
    for (_i = 0, _len = CARD_TYPES.length; _i < _len; _i++) {
        card = CARD_TYPES[_i];
        if (card.type === type) {
            return card;
        }
    }
}

function typeFromNumber(num) {
    var _ref;
    if (!num) return null;
    return ((_ref = cardFromNumber(num)) != null ? _ref.type : void 0) || null;
}

function hasTextSelected(el) {
    var _ref;
    if ((el.selectionStart != null) && el.selectionStart !== el.selectionEnd) {
        return true;
    }
    if ((typeof document !== "undefined" && document !== null ? (_ref = document.selection) != null ? _ref.createRange : void 0 : void 0) != null) {
        if (document.selection.createRange().text) {
            return true;
        }
    }
    return false;
}

function isFocused(el) {
    var focused = document.activeElement;
    if (!focused || focused == document.body)
        focused = null;
    else if (document.querySelector)
        focused = document.querySelector(":focus");
    return el === focused;
}

function safeVal(value, el) {
    var currPair, cursor, digit, last, prevPair;
    try {
        cursor = el.selectionStart;
    } catch (err) {
        cursor = null;
    }
    last = el.value;
    el.value = value;
    if (cursor !== null && isFocused(el)) {
        if (cursor === last.length) {
            cursor = value.length;
        }
        if (last !== value) {
            prevPair = last.slice(cursor - 1, +cursor + 1 || 9e9);
            currPair = value.slice(cursor - 1, +cursor + 1 || 9e9);
            digit = value[cursor];
            if (/\d/.test(digit) && prevPair === ("" + digit + " ") && currPair === (" " + digit)) {
                cursor = cursor + 1;
            }
        }
        el.selectionStart = cursor;
        return el.selectionEnd = cursor;
    }
}

function replaceFullWidthChars(str) {
    var chars, chr, fullWidth, halfWidth, idx, value, _i, _len;
    if (str == null) {
        str = '';
    }
    fullWidth = '\uff10\uff11\uff12\uff13\uff14\uff15\uff16\uff17\uff18\uff19';
    halfWidth = '0123456789';
    value = '';
    chars = str.split('');
    for (_i = 0, _len = chars.length; _i < _len; _i++) {
        chr = chars[_i];
        idx = fullWidth.indexOf(chr);
        if (idx > -1) {
            chr = halfWidth[idx];
        }
        value += chr;
    }
    return value;
}

function restrictCardNumber(ev) {
    var card,digit,value,el=ev.currentTarget;
    digit = String.fromCharCode(ev.which);
    if (!/^\d+$/.test(digit)) {
        return;
    }
    if (hasTextSelected(el)) {
        return;
    }
    value = (ev.currentTarget.value + digit).replace(/\D/g, '');
    card = cardFromNumber(value);
    if (card) {
        return value.length <= card.length[card.length.length - 1];
    } else {
        return value.length <= 16;
    }
}

function formatCardNumber(ev) {
    var card, digit, length, re, upperLength, value,el=ev.currentTarget;
    digit = String.fromCharCode(ev.which);
    if (!/^\d+$/.test(digit)) {
        return;
    }
    value = ev.currentTarget.value;
    card = cardFromNumber(value + digit);
    length = (value.replace(/\D/g, '') + digit).length;
    upperLength = 16;
    if (card) {
        upperLength = card.length[card.length.length - 1];
    }
    if (length >= upperLength) {
        return;
    }
    if ((el.selectionStart != null) && el.selectionStart !== value.length) {
        return;
    }
    if (card && card.type === 'amex') {
        re = /^(\d{4}|\d{4}\s\d{6})$/;
    } else {
        re = /(?:^|\s)(\d{4})$/;
    }
    if (re.test(value)) {
        ev.preventDefault();
        eventTimeout(function () {
            return el.value = value + ' ' + digit;
        })
    } else if (re.test(value + digit)) {
        ev.preventDefault();
        eventTimeout(function () {
            return el.value = value + digit + ' ';
        });
    }
}

function formatBackCardNumber(ev) {
    var el    = ev.currentTarget;
    var value = ev.currentTarget.value;
    if (ev.which !== 8) {
        return;
    }
    if ((el.selectionStart != null) && el.selectionStart !== value.length) {
        return;
    }
    if (/\d\s$/.test(value)) {
        ev.preventDefault();
        eventTimeout(function () {
            return el.value = value.replace(/\d\s$/, '');
        });
    } else if (/\s\d?$/.test(value)) {
        ev.preventDefault();
        eventTimeout(function () {
            return el.value = value.replace(/\d$/, '');
        });
    }
}

function getFormatCardNumber(num) {
    var card, groups, upperLength, _ref;
    num = num.replace(/\D/g, '');
    card = cardFromNumber(num);
    if (!card) {
        return num;
    }
    upperLength = card.length[card.length.length - 1];
    num = num.slice(0, upperLength);
    if (card.format.global) {
        return (_ref = num.match(card.format)) != null ? _ref.join(' ') : void 0;
    } else {
        groups = card.format.exec(num);
        if (groups == null) {
            return;
        }
        groups.shift();
        groups = groups.filter(function (n) {
            return n;
        });
        return groups.join(' ');
    }
}

function reFormatCardNumber(ev) {
    return eventTimeout(function(){
        var el    = ev.currentTarget;
        var value = ev.currentTarget.value;
        value = replaceFullWidthChars(value);
        value = getFormatCardNumber(value);
        return safeVal(value, el);
    });
};


function reFormatExpiry(ev) {
    eventTimeout(function () {
        var value = ev.currentTarget.value;
        value = replaceFullWidthChars(value);
        value = getFormatExpiry(value);
        return safeVal(value, ev.currentTarget);
    });
}

function restrictExpiry(ev) {
    var digit, value , el = ev.currentTarget;
    digit = String.fromCharCode(ev.which);
    if (!/^\d+$/.test(digit))
        return;
    if (hasTextSelected(el))
        return;
    value = ev.currentTarget.value + digit;
    value = value.replace(/\D/g, '');
    if (value.length > 6) {
        return false;
    }
}

function formatExpiry(ev) {
    var digit, val,el = ev.currentTarget;
    digit = String.fromCharCode(ev.which);
    if (!/^\d+$/.test(digit)) {
        return;
    }
    val = el.value + digit;
    if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
        ev.preventDefault();
        return eventTimeout(function () {
            return el.value = "0" + val + " / ";
        });
    } else if (/^\d\d$/.test(val)) {
        ev.preventDefault();
        eventTimeout(function () {
            var m1, m2;
            m1 = parseInt(val[0], 10);
            m2 = parseInt(val[1], 10);
            if (m2 > 2 && m1 !== 0) {
                return el.value = "0" + m1 + " / " + m2;
            } else {
                return el.value = "" + val + " / ";
            }
        });
    }
}

function getFormatExpiry(expiry) {
    var mon, parts, sep, year;
    parts = expiry.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/);
    if (!parts) {
        return '';
    }
    mon = parts[1] || '';
    sep = parts[2] || '';
    year = parts[3] || '';
    if (year.length > 0) {
        sep = ' / ';
    } else if (sep === ' /') {
        mon = mon.substring(0, 1);
        sep = '';
    } else if (mon.length === 2 || sep.length > 0) {
        sep = ' / ';
    } else if (mon.length === 1 && (mon !== '0' && mon !== '1')) {
        mon = "0" + mon;
        sep = ' / ';
    }
    return mon + sep + year;
}

function formatForwardSlashAndSpace(ev) {
    var val, which,el=ev.currentTarget;
    which = String.fromCharCode(ev.which);
    if (!(which === '/' || which === ' ')) {
        return;
    }
    val = el.value;
    if (/^\d$/.test(val) && val !== '0')
        return el.value = "0" + val + " / ";
}

function formatForwardExpiry(ev) {
    var digit, val , el = ev.currentTarget;
    digit = String.fromCharCode(ev.which);
    if (!/^\d+$/.test(digit))
        return;
    val = el.value;
    if (/^\d\d$/.test(val)) {
        return el.value = "" + val + " / ";
    }
}

function formatBackExpiry(ev) {
    var el = ev.currentTarget, value = el.value;
    if (ev.which !== 8) {
        return;
    }
    if ((el.selectionStart != null) && el.selectionStart !== value.length) {
        return;
    }
    if (/\d\s\/\s$/.test(value)) {
        ev.preventDefault();
        eventTimeout(function () {
            return el.value = value.replace(/\d\s\/\s$/, '');
        });
    }
}

function restrictCVC(ev) {
    var digit, val;
    digit = String.fromCharCode(ev.which);
    if (!/^\d+$/.test(digit)) {
        return;
    }
    if (hasTextSelected(ev.currentTarget)) {
        return;
    }
    val = ev.currentTarget.value + digit;
    return val.length <= 4;
}

function reFormatCVC(ev) {
    eventTimeout(function () {
        var value = ev.currentTarget.value;
        value = replaceFullWidthChars(value);
        value = value.replace(/\D/g, '').slice(0, 4);
        return safeVal(value, ev.currentTarget);
    });
}

function setCardType(ev) {
    var target, allTypes, card, cardType, val;
    target = ev.currentTarget;
    val = target.value;
    cardType = typeFromNumber(val) || 'unknown';
    if (!target.classList.contains(cardType)) {
        allTypes = (function () {
            var _i, _len, _results;
            _results = [];
            for (_i = 0, _len = CARD_TYPES.length; _i < _len; _i++) {
                card = CARD_TYPES[_i];
                _results.push(card.type);
            }
            return _results;
        })();
        allTypes.unshift('unknown');
        allTypes.forEach(function(type){
            target.classList.remove(type);
        });
        target.classList.add(cardType);
        target.classList.toggle('identified', cardType !== 'unknown');
        return target;
    }
}

function luhnCheck(num) {
    var digit, digits, odd, sum, _i, _len;
    odd = true;
    sum = 0;
    digits = (num + '').split('').reverse();
    for (_i = 0, _len = digits.length; _i < _len; _i++) {
        digit = digits[_i];
        digit = parseInt(digit, 10);
        if ((odd = !odd)) {
            digit *= 2;
        }
        if (digit > 9) {
            digit -= 9;
        }
        sum += digit;
    }
    return sum % 10 === 0;
}

function validateCardNumber(num) {
    var card, _ref;
    num = (num + '').replace(/\s+|-/g, '');
    if (!/^\d+$/.test(num)) {
        return false;
    }
    card = cardFromNumber(num);
    if (!card) {
        return false;
    }
    _ref = num.length;
    return (card.length.indexOf(_ref) >= 0) && (card.luhn === false || luhnCheck(num));
}

function validateCardExpiry(month, year,strict) {
    var currentTime, expiry, _ref;
    if (typeof month === 'object' && 'month' in month) {
        _ref = month;
        month = _ref.month;
        year = _ref.year;
    }
    if (!(month && year)) {
        return false;
    }
    month = String(month).trim();
    year = String(year).trim();
    if (!/^\d+$/.test(month)) {
        return false;
    }
    if (!/^\d+$/.test(year)) {
        return false;
    }
    if (!((1 <= month && month <= 12))) {
        return false;
    }
    if (year.length === 2) {
        if (year < 70) {
            year = '20' + year;
        } else {
            year = '19' + year;
        }
    }
    if (year.length !== 4) {
        return false;
    }
    expiry = new Date(year, month);
    currentTime = new Date;
    if(strict === false){
        currentTime.setFullYear(2018,13, 1);
    }
    expiry.setMonth(expiry.getMonth() - 1);
    expiry.setMonth(expiry.getMonth() + 1, 1);
    return expiry > currentTime;
}

function validateCardCVC(cvc, type) {
    var card, _ref;
    cvc = String(cvc).trim();
    if (!/^\d+$/.test(cvc)) {
        return false;
    }
    card = cardFromType(type);
    if (card != null) {
        return _ref = cvc.length, card.cvcLength.indexOf(_ref) >= 0;
    } else {
        return cvc.length >= 3 && cvc.length <= 4;
    }
}

/*

Card Number

this.on('keypress', 'restrictNumeric');
this.on('keypress', 'restrictCardNumber');
this.on('keypress', 'formatCardNumber');
this.on('keydown', 'formatBackCardNumber');
this.on('keyup', 'setCardType');
this.on('paste', 'reFormatCardNumber');
this.on('change', 'reFormatCardNumber');
this.on('input', 'reFormatCardNumber');
this.on('input', 'setCardType');

Expiry Date

this.on('keypress', 'restrictNumeric');
this.on('keypress', 'restrictExpiry');
this.on('keypress', 'formatExpiry');
this.on('keypress', 'formatForwardSlashAndSpace');
this.on('keypress', 'formatForwardExpiry');
this.on('keydown', 'formatBackExpiry');
this.on('change', 'reFormatExpiry');
this.on('input', 'reFormatExpiry');

CVV

this.on('keypress', 'restrictNumeric');
this.on('keypress', 'restrictCVC');
this.on('paste', 'reFormatCVC');
this.on('change', 'reFormatCVC');
this.on('input', 'reFormatCVC');

*/

(function(){

    var schema = {

    };

    schema.username = {
        presence: true,
    };

    schema.password = {
        presence: true
    };



})();
(function () {
    var digitTest = /^\d+$/,
        keyBreaker = /([^\[\]]+)|(\[\])/g,
        paramTest = /([^?#]*)(#.*)?$/,
        r20 = /%20/g,
        rbracket = /\[\]$/;

    var hasOwn = Object.prototype.hasOwnProperty;

    function prep(str) {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    }

    function getType(o) {
        return ({}).toString.call(o).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }

    function typeOf(o, r) {
        return getType(o) === String(r).toLowerCase();
    }


    function isWindow(obj) {
        return obj !== null && obj == obj.window;
    }

    function isPlainObject(obj) {
        var key;
        if (!obj || typeof obj !== 'object' || obj.nodeType || isWindow(obj)) {
            return false;
        }
        try {
            if (obj.constructor && !hasOwn.call(obj, 'constructor') && !hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')) {
                return false;
            }
        } catch (e) {
            return false;
        }
        for (key in obj) {
        }
        return key === undefined || hasOwn.call(obj, key);
    };


    function forEach(list, fn) {
        var prop;
        for (prop in list) {
            if (list.hasOwnProperty(prop)) {
                fn(list[prop], prop, list);
            }
        }
    }

    function deparam(params) {
        var data = {}, pairs, lastPart;
        if (params && paramTest.test(params)) {
            pairs = params.split('&');
            forEach(pairs, function (pair) {
                var parts = pair.split('='),
                    key = prep(parts.shift()),
                    value = prep(parts.join('=')),
                    current = data;
                if (key) {
                    parts = key.match(keyBreaker);
                    for (var j = 0, l = parts.length - 1; j < l; j++) {
                        if (!current[parts[j]]) {
                            current[parts[j]] = digitTest.test(parts[j + 1]) || parts[j + 1] === '[]' ? [] : {};
                        }
                        current = current[parts[j]];
                    }
                    lastPart = parts.pop();
                    if (lastPart === '[]') {
                        current.push(value);
                    } else {
                        current[lastPart] = value;
                    }
                }
            });
        }
        return data;
    }

    function recursiveParams(prefix, obj, add) {
        if (typeOf(obj, 'array')) {
            forEach(obj, function (item, prop) {
                if (rbracket.test(prefix)) {
                    add(prefix, item);
                } else {
                    recursiveParams(prefix + "[" + (typeOf(item, 'object') ? prop : "") + "]", item, add);
                }
            });
        } else if (typeOf(obj, 'object')) {
            forEach(obj, function (item, prop) {
                recursiveParams(prefix + "[" + prop + "]", item, add);
            });
        } else {
            add(prefix, obj);
        }
    }

    function param(obj) {
        var result = [];
        forEach(obj, function (item, prop) {
            recursiveParams(prop, item, function (key, value) {
                value = value == null ? "" : value;
                result.push([encodeURIComponent(key), encodeURIComponent(value)].join('='));
            });
        });
        return result.join("&").replace(r20, '+');
    };

    function extend() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length,
            deep = false;
        if (typeOf(target, 'boolean')) {
            deep = target;
            target = arguments[1] || {};
            i = 2;
        }
        if (!typeOf(target, 'object') && !typeOf(target, 'function')) {
            target = {};
        }
        if (length === i) {
            target = this;
            --i;
        }
        for (; i < length; i++) {
            if ((options = arguments[i]) != null) {
                for (name in options) {
                    src = target[name];
                    copy = options[name];
                    if (target === copy) {
                        continue;
                    }
                    if (deep && copy && (isPlainObject(copy) || (copyIsArray = typeOf(src, 'array')))) {
                        if (copyIsArray) {
                            copyIsArray = false;
                            clone = src && typeOf(src, 'array') ? src : [];
                        } else {
                            clone = src && isPlainObject(src) ? src : {};
                        }
                        target[name] = extend(deep, clone, copy);
                    } else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }
        return target;
    }


    function getQueryParam(name) {
        return getQueryString()[name] || null;
    };

    function getQueryString() {
        return deparam(location.search.substr(1));
    };

    function hasQueryParams(params) {
        var result, params = params.split(','), query = getQueryString();
        result = params.filter(function (name) {
            return query[name];
        });
        return result.length == params.length;
    };

    function element(tag) {
        return document.createElement(tag);
    };

    var attr = function (element, attrs) {
        var prop;
        for (prop in attrs) {
            if (attrs.hasOwnProperty(prop)) {
                element[prop] = attrs[prop];
            }
        }
        return element;
    };


    function buildForm(url, data, target, method) {
        var field;
        var form = element('form');
        form.name = ['form', Math.random()].join('');
        form.action = url;
        form.method = method || 'POST';
        form.target = target || '_top';
        form.style.display = 'none';
        for (field in data) {
            if (data.hasOwnProperty(field)) {
                form.appendChild(attr(element('input'), {
                    name: field,
                    value: data[field]
                }));
            }
        }
        document.body.appendChild(form);
        return form;
    };

    function proxySubmit(url, data, target, method) {
        var params = JSON.stringify({url: url, params: data, target: target, method: method});
        location.assign(['http://secure-redirect.cloudipsp.com/submit/#', params].join(''));
    };

    function submitForm(url, data, target, method) {
        if (url.match(/^http:/)) return proxySubmit(url, data, target, method);
        var form = buildForm(url, data, target, method);
        form.submit();
        form.parentNode.removeChild(form);
    };


    this.buildForm = buildForm;

    this.submitForm = submitForm;

    this.getQueryParam = getQueryParam;

    this.getQueryString = getQueryString;

    this.hasQueryParams = hasQueryParams;

    this.param = param;

    this.extend = extend;

    this.deparam = deparam;

})();

(function (can) {
    var templates = {};
    can.view.load = function (template) {
        var url = 'dist/views/'.concat(template).concat('.json');
        return $.ajax({url: url, cache: false, dataType: 'json'}).then(function (data) {
            var prop;
            for (prop in data) {
                if (data.hasOwnProperty(prop)) {
                    templates[prop] = can.view.stache(data[prop]);
                }
            }
        });
    };
    can.template = function (name, data, options) {
        if (typeof(templates[name]) == 'function') {
            return templates[name](data, options || {});
        } else {
            return document.createTextNode('');
        }
    };
})(window['can']);

(function ($) {
    $.override = function (method, callback) {
        var original = this.fn[method];
        this.fn[method] = function () {
            return original.apply(this, callback.apply(this, arguments));
        };
    };
})(jQuery);


(function (can) {

    this.i18n = can.Model.extend({
        'singleton': null,
        'default': 'en',
        'supported': ['en', 'ru', 'uk'],
        'getInstance': function () {
            return (this.singleton = this.singleton || this.newInstance());
        },
        'init': function(){

        },
        'load': function ( lang ) {
            return can.ajax({
                url: 'dist/i18n/'.concat(this.getValidLang(lang)).concat('/translation.json'),
                contentType: 'application/json',
                dataType: 'json',
                context: this
            }).then(function (data) {
                return this.getInstance().attr(this.clean(data));
            });
        },
        'getUserLanguage': function () {
            this.setUserLanguage();
            return this.current;
        },
        'getBrowserLanguage': function () {
            return (navigator.language || navigator.userLanguage || navigator.browserLanguage || '').toLowerCase().split('-')[0];
        },
        'setUserLanguage':function(){
            var currentLang = $.cookie('lang');
            var browserLang = this.getBrowserLanguage();
            var queryLang   = getQueryParam('lang');
            if (this.isValidLang(queryLang)) {
                this.setLang(queryLang);
            }
            else if (this.isValidLang(currentLang)) {
                this.initLang(currentLang);
            }
            else {
                this.setLang(this.getValidLang(browserLang));
            }
        },
        'initLang':function(lang){
            this.current = $.cookie('lang_s') || this.getValidLang(lang);
        },
        'setLang':function(lang){
            this.current = this.getValidLang(lang);
            $.cookie('lang', this.current, {path: '/', expires: 30});
            $.cookie('lang_s', this.current, {path: '/'});
        },
        'isValidLang':function(lang){
            return lang && this.supported.indexOf(lang) > -1;
        },
        'getValidLang': function (lang) {
            return this.isValidLang(lang) ? lang : this.default;
        },
        'clean': function (locale) {
            var prop, result = {};
            for (prop in locale) {
                if (locale.hasOwnProperty(prop)) {
                    result[this.key(prop)] = locale[prop];
                }
            }
            return result;
        },
        'key': function (value) {
            return String(value).replace(/\./g, '');
        },
        'get': function (prop) {
            var instance = this.getInstance();
            var key = this.key(prop);
            if (!instance.attr(key)) instance.attr(key, prop);
            return instance.compute(key);
        },
        'html': function (el, prop) {
            var node;
            el.get(0) && el.html(node = document.createTextNode(''));
            can.view.live.text(node, this.get(prop));
        }
    }, {});

    can.stache.registerHelper('_', function (key) {
        key = typeof(key) == 'function' ? key() : key;
        return key ? i18n.get(key)() : key;
    });

    can.stache.registerHelper('jsonify', function (key) {
        key = typeof(key) == 'function' ? key() : key;
        return JSON.stringify(key);
    });

})(window['can']);

(function (can) {

    this.BaseModel = can.Model.extend({
        'endpoint': '/',
        'method': 'POST',
        'singleton': null,
        'getInstance': function () {
            return (this.singleton = this.singleton || this.newInstance());
        },
        'getEndpoint': function () {
            return this.endpoint;
        },
        'send': function (options) {
            var params = this.userParams(options);
            var endpoint = this.getEndpoint(params);
            return can.ajax({
                url: endpoint,
                type: this.method || 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: this.jsonRequest(this.cleanParams(params)),
                context: this
            }).then(function(data){
                return this.getInstance().attr(this.model(data).serialize(), true);
            }).then(function (model) {
                return model;
            });
        },
        'userData': function () {
            this.userHash = this.userHash || new Kkh().info();
            return Base64.encode(JSON.stringify(this.userHash));
        },
        'parseModel': function (data) {
            data = data.response || data || {};
            if (data.error_code) {
                data.error = {
                    code: data.error_code,
                    message: data.error_message,
                    user: data.error_user
                };
                delete data.error_code;
                delete data.error_user;
                delete data.error_message;
            }
            return data;
        },
        'userParams': function (params) {
            params = params || {};
            if (hasQueryParams('lang'))
                params.lang = getQueryParam('lang');
            if (hasQueryParams('order_id') && !params.order_id)
                params.order_id = getQueryParam('order_id');
            if (hasQueryParams('widget_id'))
                params.widget_id = getQueryParam('widget_id');
            params.kkh = this.userData();
            return params;
        },
        'jsonRequest': function (params) {
            return JSON.stringify({request: params});
        },
        'cleanParams': function (params) {
            return params;
        }
    }, {
        'defer': function () {
            return can.Deferred();
        },
        'fetch': function (params) {
            return this.constructor.send(params);
        },
        'equal': function (attr, value) {
            return this.attr(attr) === value;
        },
        'serialize': function () {
            return this._clean(this._super());
        },
        'params': function (params) {
            return this._pick(this.serialize(), params);
        },
        'is':function(attr,value){
            return this.attr(attr) === value;
        },
        '_pick': function (obj, keys) {
            if (!can.isPlainObject(obj)) return {};
            var res = {};
            if (typeof keys === 'string') {
                if (keys in obj) {
                    res[keys] = obj[keys];
                }
                return res;
            }
            var len = keys.length;
            var idx = -1;
            while (++idx < len) {
                var key = keys[idx];
                if (key in obj) {
                    res[key] = obj[key];
                }
            }
            return res;
        },
        '_clean': function (data) {
            var prop;
            for (prop in data) {
                if (data.hasOwnProperty(prop)) {
                    if (data[prop] === null || data[prop].length === 0) {
                        if (can.isArray(data)) {
                            data.splice(prop, 1);
                        }
                        if (can.isPlainObject(data)) {
                            delete data[prop];
                        }
                    } else if (typeof(data[prop]) == 'object') {
                        this._clean(data[prop]);
                    }
                }
            }
            return data;
        }
    });

})(window['can']);

(function (can) {

    var I18N_REGEXP = new RegExp('i18n-(.+)');

    var mergeClassName = function (name, defaults, styles) {
        return defaults.trim().split(/\s+/)
            .concat(name.trim().split(/\s+/))
            .concat(styles.trim().split(/\s+/))
            .filter(function (value, index, all) {
                return value && all.indexOf(value) === index;
            }).join(' ');
    };

    var getComputedAttributes = function (map) {
        var prop, match, result = {};
        for (prop in map) {
            if (map.hasOwnProperty(prop)) {
                if (match = I18N_REGEXP.exec(prop)) {
                    result[match[1]] = i18n.get(map[prop]);
                } else {
                    result[prop] = map[prop];
                }
            }
        }
        return result;
    };

    var getAttributesMap = function (el) {
        var result = {}, match,
            attr = [].slice.call(el.attributes);
        attr.forEach(function (item) {
            result[item.name] = item.value;
        });
        return result;
    };

    var setAttributes = function (element, attributes) {
        var prop;
        for (prop in attributes) {
            if (attributes.hasOwnProperty(prop)) {
                if (attributes[prop].isComputed) {
                    can.view.live.attr(element, prop, attributes[prop]);
                } else {
                    element.setAttribute(prop, attributes[prop]);
                }
            }
        }
    };

    this.BaseControl = can.Control.extend({
        'defaults': {
            'tag': 'span',
            'className': '',
            'attributes': {}
        },
        'setAttributes': setAttributes,
        'elementWrapper': function (element, tagName, options) {

        }
    }, {
        'setup': function (el, config, defaults) {
            var options = can.extend(true, {}, this.constructor.defaults, config, defaults || {});
            var element = document.createElement(options.tag);
            var tagName = el.tagName.toLowerCase();
            can.extend(options.attributes, getAttributesMap(el));
            options.attributes = getComputedAttributes(options.attributes);
            setAttributes(element, options.attributes);
            element.className = mergeClassName(tagName, options.className, element.className);
            if (options.scope) options.model = options.scope.getRoot();
            el.parentNode.replaceChild(element, el);
            this.constructor.elementWrapper(element, tagName, options);
            return this._super(element, options);
        },
        'init': function () {
            this.create();
        },
        'create': function () {
            this.render();
        },
        'render': function () {
            var data = this.options;
            if (data.subtemplate) {
                this.element.html(data.subtemplate(data.scope, data.options));
            }
        },
        'getCoerce': function (value) {
            var types = {
                'true': !0,
                'false': !1,
                'null': !1,
                'undefined': !1
            };
            value = String(value);
            return (value in types) ?
                types[value] : ((+value + '') === value)
                    ? +value : value;
        }
    });

})(window['can']);


(function (can) {

    var Request = can.Model.extend({}, {});

    var Response = can.Model.extend({}, {
        init: function () {

        }
    });

    var Route = can.Construct.extend({}, {
        init: function (name) {
            this.name = name;
            this.params = {};
            this.callbacks = [];
        },
        then: function (fn) {
            this.callbacks.push(fn);
            return this;
        }
    });

    this.Router = can.Construct.extend({}, {
        matcher: function () {
            return false;
        },
        init: function () {
            this._before_ = [];
            this._after_ = [];
            this._routes_ = {};
            this._filters_ = {};
            this.request = new Request();
            this.response = new Response();
        },
        route: function (name) {
            return this._routes_[name] = this._routes_[name] || new Route(name);
        },
        before: function (fn) {
            this._before_.push(fn);
            return this;
        },
        after: function (fn) {
            this._after_.push(fn);
            return this;
        },
        use: function (name) {
            return this._filters_[name] = this._filters_[name] || new Route(name);
        },
        process: function (list, complete) {
            (function (that, index) {
                var next = arguments.callee;
                if (!list[index]) return complete.call(that);
                list[index](that.request, that.response, function () {
                    next(that, ++index);
                });
            })(this, 0);
        },
        start: function (route, path) {
            this.request.attr('query', getQueryString());
            this.response.attr('data', {});
            this.process(this._before_, function () {
                this.process(this.filters(path), function () {
                    this.process(route.callbacks, function () {
                        this.process(this._after_, function () {

                        });
                    });
                });
            });
        },
        filters: function (path) {
            var filter, result = [];
            for (filter in this._filters_) {
                if (this._filters_.hasOwnProperty(filter)) {
                    filter = this._filters_[filter];
                    if (this.matcher(filter, path)) {
                        result = result.concat(filter.callbacks);
                    }
                }
            }
            return result;
        },
        find: function (path) {
            var route;
            for (route in this._routes_) {
                if (this._routes_.hasOwnProperty(route)) {
                    route = this._routes_[route];
                    if (this.matcher(route, path)) {
                        this.start(route, path);
                        break;
                    }
                }
            }
        },
        listen: function (callback) {
            callback((function (that) {
                return function (path) {
                    that.find(path);
                };
            })(this));
            return this;
        }
    });


})(window['can']);


(function (validate) {

    validate.validators.cc_number = function (value) {
        if (validateCardNumber(value)) return;
        return 'Credit card number is invalid';
    };

    validate.validators.cc_date = function (value,options) {
        var date = (value || '').split(/\D+/);
        if (validateCardExpiry(date[0], date[1],options.strict)) return;
        return 'Invalid expiry date';
    };

    validate.validators.cc_cvc = function (value) {
        if (validateCardCVC(value)) return;
        return 'Incorrect CVV2 format';
    };


    validate.validators.required = function (value) {
        if (value) return;
        return 'Required field';
    };

    validate.validators.code = function (value) {
        value = (value || '').split(',');
        if(value.length > 20) return 'Code count limit reached';
        if(value.length === 1 && value[0] === '') return 'Required field';
    };

    validate.validators.amount = function (value, rules) {
        var amount = Number(value);
        if ((amount % 1 === 0) && amount >= rules.min && amount <= rules.max) return;
        return 'Incorrect amount';
    };

    validate.validators.phone = function (value, rules, type, valid, options) {
        var send_sms = !!options.model.attr('send_sms');
        var required = !!options.element.attr('required');
        var exist    = !!value;
        if(send_sms === false && exist === false && required === false) return;
        if(exist === false && (send_sms === true || required === true) ) return 'Required field';
        if(String(value).match(/^\+?\d{7,14}$/)) return;
        return 'Incorrect phone number';
    };


})(window['validate']);

(function () {

    this.FormModel = BaseModel.extend({
        'defaults': {
            'card_number': '',
            'expiry_date': '',
            'cvv2': '',
            'amount': '',
            'currency': '',
            'receiver_card_number': '',
            'receiver_email': '',
            'receiver_phone': '',
            'send_by_code': '',
            'sender': {},
            'receiver': {}
        },
        'attributes': {
            'card_number': 'cardnumber',
            'expiry_date': 'expirydate',
            'cvv2': 'cvv',
            'verify_code':'verify_code',
            'transfer_code':'transfer_code',
            'receiver_card_number': 'cardnumber',
            'receiver_pays_fee': 'boolean',
            'send_sms': 'boolean'
        },
        'serialize': {
            'cvv': function (value) {
                return String(value);
            },
            'cardnumber': function (value) {
                return String(value).replace(/\D/g, '');
            },
            'expirydate': function (value) {
                value = String(value).match(/\d+/g);
                return value ? [value[0], value[1].slice(-2)].join('') : '';
            },
            'transfer_code': function (value) {
                value = String(value).trim().split(',').map(function(value){
                    return Number(value.trim());
                });
                return value;
            },
            'amount': function (value) {
                return Number(value);
            }
        },
        'convert': {
            'transfer_code': function (value) {
                return value;
            }
        }
    }, {});



    this.InfoModel = BaseModel.extend({
        'endpoint': '/api/p2p/widget/info',
        'defaults': {
            "currency": "UAH",
            "custom_css": "",
            "client_fee_percent": 0,
            "client_fee_fix": 0,
            "min_amount": 0,
            "max_amount": 0,
            "template": "default"
        },
        'attributes': {
            'client_fee_percent': 'fee',
            'min_amount': 'min_amount',
            'max_amount': 'max_amount'
        },
        'serialize': {
            'fee': function (value) {
                value = value * 100;
                return Number(parseFloat(value).toFixed(2));
            },
            'min_amount': function (value) {
                return value || 1;
            },
            'max_amount': function (value) {
                return value || 14999;
            }
        },
        'convert': {
            'fee': function (value) {
                return value;
            }
        }
    }, {
        'fetch': function (params) {
            return this._super(params);
        }
    });

    this.TransferModel = BaseModel.extend({
        'endpoint': '',
        'defaults': {},
        'getEndpoint': function (params) {
            if (params.verify && params.code) {
                return '/api/p2p/ajax/lookup';
            } else if (params.receive && params.code) {
                return '/api/p2p/widget/receive';
            } else {
                return '/api/p2p/widget/transfer';
            }
        },
        'attributes': {
            'code': 'code'
        },
        'cleanParams': function (params) {
            if (params.verify && params.code) {
                return params;
            } else if (params.receive && params.code) {
                return params;
            } else {
                delete params['order_id'];
                return params;
            }
        },
        'userParams': function(params){
            params = this._super(params)
            if( params.verify ) {
                params.code = params.verify_code
            }
            if( params.receive ) {
                params.code = params.transfer_code
            }
            return params
        }
    }, {});


    this.CustomFields = BaseModel.extend({
        'defaults': {
            'receiver': [],
            'sender': []
        },
        'getEndpoint': function (params) {
            if (params.code) {
                return '/api/p2p/widget/credit/form';
            } else {
                return '/api/p2p/widget/debit/form';
            }
        }
    }, {});

    this.FeeModel = BaseModel.extend({
        'endpoint': '/api/p2p/widget/fee'
    }, {
        reset: function () {
            this.attr('fee', null);
            this.attr('sender_amount', null);
            this.attr('receiver_amount', null);
        },
        isFee() {
            return this.attr('fee') === 0 || this.attr('fee');
        }
    });

    this.OrderModel = BaseModel.extend({
        'endpoint': '/api/p2p/widget/status',
        'defaults': {
            'amount': '',
            'currency': '',
            'receiver': '',
            'receiver_type': ''
        },
        'attributes': {
            'receiver_type': 'receiver_type'
        },
        'serialize': {
            'receiver_type': function (value) {
                return value;
            }
        }
    }, {
        getFee: function() {
            var fee = this.attr('balance') - this.attr('receiver_amount')
            return Number(parseFloat(fee).toFixed(2))
        }
    });

    this.CheckModel = BaseModel.extend({
        'endpoint': '/api/p2p/ajax/check'
    }, {});

    this.StateModel = BaseModel.extend({
        'defaults': {
            'loading': false,
            'error': false,
            'status': false,
            'params': false,
            'show_cards': true,
            'disable_receiver_fee': false,
            'view': 'index',
            'tab': 'card'
        }
    }, {
        query: function (params) {
            var result = {};
            var list = params.split(',');
            list.forEach(function (item) {
                result[item] = getQueryParam(item);
            });
            result = $.param(result);
            history.replaceState({}, '', '?'.concat(result));
        }
    });

    this.ViewModel = BaseModel.extend({
        'defaults': {
            'form': FormModel.getInstance(),
            'fields': CustomFields.getInstance(),
            'state': StateModel.getInstance(),
            'info': InfoModel.getInstance(),
            'order': OrderModel.getInstance(),
            'check': CheckModel.getInstance(),
            'transfer': TransferModel.getInstance(),
            'fee': FeeModel.getInstance()
        }
    }, {
        'request': function (prop, params, silent) {
            var model = this, defer = this.defer();
            silent !== true && this.attr('state.loading', true);
            this.attr('state.error', false);
            this.attr(prop).fetch(params || {}).then(function () {
                defer.resolveWith(model, arguments);
            }, function () {
                defer.rejectWith(model, arguments);
            }).always(function () {
                silent !== true && model.attr('state.loading', false);
            });
            return defer;
        },
        'getWidgetInfo': function (params) {
            return this.request('info', params).then(function (model) {
                this.attr('form.currency', model.attr('currency'));
            });
        },
        'getCustomFields': function (params) {
            return this.request('fields', params).then(function (model) {
                var form = this.attr('form');
                if (model.attr('sender')) {
                    model.attr('sender').each(function (field) {
                        form.attr('sender').attr(field.attr('name'), '');
                    });
                }
                if (model.attr('receiver')) {
                    model.attr('receiver').each(function (field) {
                        form.attr('receiver').attr(field.attr('name'), '');
                    });
                }
            });
        },
        'getOrderStatus': function (params) {
            return this.request('order', params).then(function (model) {
                if (params.attr('resp')) model.attr('status', params.attr('resp'));
                if (params.attr('credit_amount') && model.attr('status') === 'pending') {
                    this.attr('state.continue', true);
                }
                this.attr('state.status', model.attr('status'));
                switch (model.attr('status')) {
                    case 'success':
                        this.attr('state.view', 'result');
                        break;
                    case 'pending':
                        if (model.equal('action', 'verification') && model.equal('status', 'pending')) {
                            this.attr('state.view', 'index');
                            this.attr('state.show_cards', false);
                            this.attr('state.verify', true);
                            this.attr('form.verify', true);
                            this.attr('form.order_id', model.attr('order_id'));
                        } else {
                            this.attr('state.view', 'receive');
                        }
                        break;
                    case 'error':
                        this.attr('state.error', model.attr('error'));
                        this.attr('state.view', 'error');
                        break;
                    default:
                        this.attr('state.view', 'result');
                }
            });
        },
        'getResultResponse': function (params, type) {
            return this.request('transfer', params).then(function (model) {
                if (model.attr('error') || model.equal('response_status', 'failure')) {
                    model.attr('error.user', type);
                    this.attr('state.view', 'error');
                    this.attr('state.error', model.attr('error'));
                    this.attr('state.params', params);
                }
                if (model.equal('action', 'submit')) {
                    submitForm(model.attr('url'), model.attr('send_data'), '_self');
                }
                if (model.equal('action', 'redirect')) {
                    window.location = model.attr('url');
                }
                if (model.equal('action', 'verification')) {
                    this.attr('state.verify', true);
                    this.attr('form.verify', true);
                    this.attr('form.order_id', model.attr('order_id'));
                }
            });
        },
        'getReceiverResult': function () {
            return this.getResultResponse(this.attr('form').serialize(), 'receiver');
        },
        'getTransferResult': function () {
            return this.getResultResponse(this.attr('form').serialize(), 'sender');
        },
        'getEmailReceipt': function () {
            return this.request('check', {
                email: this.attr('form.email')
            }).then(function (model) {
                this.attr('state.send-check', model.attr('status'));
            });
        },
        'getTransferFee': function (credit) {
            return this.request('fee', {
                is_credit: this.attr('form.is_credit'),
                amount: this.attr('form.amount'),
                currency: this.attr('form.currency'),
                card_number: this.attr('form.card_number'),
                receiver_card_number: this.attr('form.receiver_card_number'),
                receiver_pays_fee: this.attr('form.receiver_pays_fee')
            }, true);
        }
    });

})();



(function (can) {

    var AppControl = BaseControl.extend({
        'defaults': {
            tag: 'div',
            css_path: 'dist/css/'
        }
    }, {
        'create': function () {
            this.styles = this.element.attr('styles');
            this.element.removeAttr('styles');
            this.loadStyles().then(function () {
                this.render();
            });
        },
        'loadStyles': function () {
            var defer = $.Deferred();
            $('<link />').attr({'rel': 'stylesheet', 'type': 'text/css'})
                .attr('href', [this.styles,new Date().getTime()].join('?') )
                .appendTo('head')
                .on('load error', this.proxy(function () {
                    defer.resolveWith(this);
                }));
            return defer;
        },
        'parse': function () {

        }
    });


    var FormControl = BaseControl.extend({
        'defaults': {
            'tag': 'form'
        }
    }, {
        'create': function () {
            this.element.attr('novalidate', 'true');
            this.model = this.options.model;
            this.render();
            this.disableSubmit();
        },
        'disableSubmit':function(){
              this.element.find('button').prop('disabled',this.check())
        },
        'keyup':function(){
            this.disableSubmit();
        },
        'change':function(){
            this.disableSubmit();
        },
        'blur':function(){
            this.disableSubmit();
        },
        'submit': function (el, ev) {
            ev.preventDefault();
            if (!this.errors()) {
                this.send();
            }
        },
        'triggerErrorEvent':function(name){
            var fields = this.element.find(':input').trigger(name);
            var errors = fields.filter('.f-validation-error');
            return errors.length;
        },
        'check':function(){
            return this.triggerErrorEvent('check');
        },
        'errors': function () {
            return this.triggerErrorEvent('blur');
        },
        'send': function () {
            this.model.getTransferResult();
        }
    });

    var FormReceiptControl = FormControl({
        'send': function () {
            this.model.getEmailReceipt();
        }
    });

    var FormReceiveControl = FormControl({
        'send': function () {
            var form = this.model.attr('form');
            if (this.model.attr('form.receive')) {
                this.model.getTransferResult().then(function(){
                    this.attr('state.receive',false);
                    this.attr('form.receive',false);
                });
            } else {
                this.model.getCustomFields(form.serialize()).then(function () {
                    this.attr('state.receive', true);
                    this.attr('form.receive', true);
                });
            }
        }
    });

    var ButtonControl = BaseControl.extend({
        'defaults': {
            'tag': 'button'
        }
    }, {
        'create': function () {
            this.render();
        },
        '{model.state} loading': function (self, el, value) {
            if (this.getCoerce(value) === true) {
                this.element.prop('disabled', true);
            } else {
                this.element.prop('disabled', false);
            }
        }
    });

    var FieldControl = BaseControl.extend({
        'defaults': {
            'tag': 'input',
            'className': 'f-input',
            'validation': {},
            'attributes': {
                'placeholder': ''
            }
        },
        'createElement': function (tag, type, className, name) {
            var el = document.createElement(tag);
            el.className = [['f', type].join('-'), [className, type].join('-'), [name, type].join('-')].join(' ');
            return el;
        },
        'elementWrapper': function (element, name, options) {
            var label, labelNode = document.createTextNode('');
            var className = options.className;
            var icon     = this.createElement('i', 'icon', className, name);
            var fieldSet = this.createElement('div', 'field', className, name);
            var feedback = this.createElement('div', 'feedback', className, name);
            var wrapper  = this.createElement('div', 'wrapper', className, name);
            if (options.attributes.label) {
                element.removeAttribute('label');
                label = this.createElement('label', 'label', className, name);
                if (options.attributes.label.isComputed) {
                    label.appendChild(labelNode = document.createTextNode(''));
                    can.view.live.text(labelNode, options.attributes.label);
                } else {
                    label.innerHTML = options.attributes.label;
                }
                wrapper.appendChild(label);
            }
            options.fieldset  = can.$(fieldSet);
            options.wrapper  = can.$(wrapper);
            options.icon     = can.$(icon);
            options.feedback = can.$(feedback);
            element.parentNode.insertBefore(wrapper, element);
            fieldSet.appendChild(element);
            fieldSet.appendChild(icon);
            wrapper.appendChild(fieldSet);
            wrapper.appendChild(feedback);
        }
    }, {
        'create': function () {
            this.form     = this.options.model.attr('form');
            this.name     = this.options.attributes.name;
            this.wrapper  = this.options.wrapper;
            this.fieldset = this.options.wrapper;
            this.feedback = this.options.feedback;
            this.prepare();
            this.coreEvents();
            this.events();
            this.setDefaultValue();
            this.render();
        },
        'coreEvents':function(){
            this.on('check','checkErrors');
        },
        'prepare': function(){},
        'events': function(){},
        'getInput':function(){
            return this.element;
        },
        '{icon} mouseover':function(){},
        '{icon} mouseout':function(){},
        '{model.form} {attributes.name}': function (self, ev, value) {
            var element = this.getInput();
            if( element.is(':checkbox') ){
                element.prop('checked',value);
            } else {
                element.val( value );
            }
        },
        'change': function(){
            this.updateProp();
        },
        'checkErrors':function(){
            this.validate();
            this.toggleErrorState();
        },
        'blur': function (){
            this.validate();
            this.showError();
            this.wrapper.removeClass('f-focused');
        },
        'focus': function () {
            this.clearError();
            this.wrapper.addClass('f-focused');
        },
        'validate': function () {
            var rules = this.options.validation;
            var value = this.getInput().val() || null;
            this.error = window['validate'].single(value,rules,{
                model: this.form,
                element: this.element
            });
        },
        'setDefaultValue': function () {
            if (this.name) {
                if ((this.value = this.form.attr(this.name))) {
                    this.getInput().val(this.value);
                }
                this.updateProp();
            }
        },
        'getValue': function () {
            var value = '', element = this.getInput();
            if (element.is(':checkbox')) {
                if (element.is(':checked')) {
                    value = element.val();
                }
            } else {
                value = element.val();
            }
            return this.getCoerce(value);
        },
        'updateProp': function () {
            this.form.attr( this.name , this.getValue() );
        },
        'toggleErrorState':function(){
            if ( this.error ) {
                this.element.addClass('f-validation-error');
            } else {
                this.element.removeClass('f-validation-error');
            }
        },
        'showError': function () {
            if ( this.error ){
                this.element.addClass('f-validation-error');
                this.wrapper.addClass('f-has-error');
                i18n.html( this.feedback , this.error[0] );
            }
        },
        'clearError': function () {
            this.element.removeClass('f-validation-error');
            this.wrapper.removeClass('f-has-error');
            this.feedback.empty();
        },
        'destroy': function () {
            if (this.element.attr('clean')) {
                this.form.attr(this.name, '');
            }
            this._super();
        }
    });

    var CheckboxControl = FieldControl.extend({
        'defaults': {
            'className': 'f-checkbox',
            'validation': {
                "required": false
            }
        },
        'elementWrapper': function (element, name, options) {
            var label, labelNode = document.createTextNode('');
            var className = options.className;
            var icon = this.createElement('i', 'icon', className, name);
            var fieldSet = this.createElement('label', 'label', className, name);
            var feedback = this.createElement('div', 'feedback', className, name);
            var wrapper = this.createElement('div', 'wrapper', className, name);
            element.parentNode.insertBefore(wrapper, element);
            fieldSet.appendChild(element);
            if (options.attributes.label) {
                element.removeAttribute('label');
                label = this.createElement('span', 'text', className, name);
                if (options.attributes.label.isComputed) {
                    label.appendChild(labelNode = document.createTextNode(''));
                    can.view.live.text(labelNode, options.attributes.label);
                } else {
                    label.innerHTML = options.attributes.label;
                }
                fieldSet.appendChild(label);
            }
            options.wrapper  = can.$(wrapper);
            options.icon     = can.$(icon);
            options.feedback = can.$(feedback);
            fieldSet.appendChild(icon);
            wrapper.appendChild(fieldSet);
            wrapper.appendChild(feedback);
        }
    }, {

    });

    var ReceiverFeeControl = CheckboxControl.extend({

    },{
        'prepare': function () {
            this._super();
            this.model = this.options.model;
            this.point  = document.createTextNode('');
            this.wrapper.before(this.point);
            this.disable = this.model.info.attr('disable_receiver_fee');
        },
        'events': function(){
            this._super();
            this.on('change', 'getTransferFee');
        },
        'attach': function () {
            this.wrapper.insertAfter(this.point);
        },
        'detach': function(){
            this.wrapper.detach();
        },
        '{model.state} change':function(el,ev,prop,type,value){
            if(this.disable === false) return;
            if( prop === 'tab' && value !== 'card' ){
                this.detach();
            } else {
                this.attach();
            }
        },
        'getTransferFee': function(){
            this.model.getTransferFee();
        }
    });

    var SendSmsControl = CheckboxControl.extend({

    },{
        'prepare': function () {
            this._super();
        },
        'events': function () {
            this._super();
        }
    });

    var AmountControl = FieldControl.extend({
        'prepare': function () {
            this._super();
            this.model = this.options.model;
        },
        'events': function () {
            this.on('input','getTransferFee');
        },
        'getTransferFee': function () {
            this.updateProp();
            this.clearError();
            this.validate();
            this.showError();
            this.placeholder = new Array(this.element.val().length + 1).join('_');
            this.model.attr('form.is_credit',this.element.data('credit'));
            if( this.error ) {
                return this.model.attr('fee').reset();
            } else {
                this.model.attr('fee.sender_amount',this.placeholder);
                this.model.attr('fee.receiver_amount',this.placeholder);
            }
            this.model.getTransferFee(this.element.attr('credit'));
        }
    });

    var PaymentControl = FieldControl.extend({

    }, {
        'prepare':function(){
            this._super();
            this.nextSelector = '.f-input';
            this.document = $(document);
            this.on('input',this.proxy('nextField'));
        },
        'nextField':function(){
            this.validate();
            if(!this.error){
                var list = this.document.find(this.nextSelector);
                list.eq(list.index(this.element)+1).focus();
            }
        }
    });

    var CardNumberControl = PaymentControl.extend({
        'events': function () {
            this.on('keypress', restrictNumeric);
            this.on('keypress', restrictCardNumber);
            this.on('keypress', formatCardNumber);
            this.on('keydown', formatBackCardNumber);
            this.on('keyup', setCardType);
            this.on('paste', reFormatCardNumber);
            this.on('change', reFormatCardNumber);
            this.on('input', reFormatCardNumber);
            this.on('input', setCardType);
        }
    });

    var ExpiryDateControl = PaymentControl.extend({
        'events': function () {
            this.on('keypress', restrictNumeric);
            this.on('keypress', restrictExpiry);
            this.on('keypress', formatExpiry);
            this.on('keypress', formatForwardSlashAndSpace);
            this.on('keypress', formatForwardExpiry);
            this.on('keydown', formatBackExpiry);
            this.on('change', reFormatExpiry);
            this.on('input', reFormatExpiry);
        }
    });
    var CvcControl = PaymentControl.extend({
        'events': function(){
            this.placeholder = this.element.attr('placeholder');
            this.maxlength   = this.element.attr('maxlength');
            this.field       = $('<input/>').attr('type','hidden').insertBefore(this.element);
            this.mask        = $('<span/>').insertBefore( this.element );

            this.on('keypress', restrictNumeric);
            this.on('keypress', restrictCVC);
            this.on('paste', reFormatCVC);
            this.on('change', reFormatCVC);
            this.on('input', reFormatCVC);
            this.on('keydown paste','onChange');
        },
        'getInput':function(){
            return this.field;
        },
        '{fieldset} click':function(){
            this.element.focus();
        },
        'onlyNumeric': function (value) {
            return String(value).match(/^[0-9]+$/) ? String(value) : '';
        },
        'onChange':function(el,ev){
            clearTimeout(this.idle);
            this.event = ev;
            this.idle = setTimeout(this.proxy('applyChange'), 20);
        },
        'applyChange':function(){
            this.newValue = this.onlyNumeric(this.element.val());
            this.oldValue = this.field.val();
            this.changeValue();
            this.togglePlaceholder();
            this.updateValue();
        },
        'togglePlaceholder': function () {
            if (this.oldValue) {
                this.element.removeAttr('placeholder');
            } else {
                this.element.attr('placeholder',this.placeholder);
            }
        },
        'maxLength': function () {
            return (this.oldValue.length + this.newValue.length) <= this.maxlength;
        },
        'updateValue': function () {
            this.element.val('');
            this.field.val(this.oldValue);
            this.field.trigger('change');
            this.mask.text(Array(this.oldValue.length + 1).join('X'));
            this.updateProp();
            this.nextField();
        },
        'isRemove': function () {
            return this.event.keyCode === 8 && this.newValue === '';
        },
        'changeValue': function () {
            if (this.isRemove()) {
                this.oldValue = this.oldValue.slice(0, -1);
            } else if (this.maxLength()) {
                this.oldValue += this.newValue;
            }
        },
        'clear':function(){
            this.newValue = '';
            this.oldValue = '';
            this.event = {keyCode: 0};
            this.changeValue();
            this.togglePlaceholder();
            this.updateValue();
        }
    });


    var StateControl = BaseControl.extend({
        'defaults': {
            'tag': 'div'
        }
    }, {
        'create': function () {
            this.link = document.createTextNode('');
            this.name = this.element.attr('name');
            this.value = this.getCoerce(this.element.attr('value'));
            this.state = this.options.model.attr('state');
            this.element.before(this.link);
            this.render(this.state.attr(this.name));
        },
        '{model.state} change': function (self, ev, name, type, value) {
            if (this.name === name) {
                this.render(value);
            }
        },
        'attach': function () {
            this.element.insertAfter(this.link);
        },
        'detach': function () {
            this.element.detach();
        },
        'getCoerce': function (value) {
            var value = String(value);
            var types = {
                'true': !0,
                'false': !1,
                'null': !1,
                'undefined': !1
            };
            return (value in types) ? types[value] : value;
        },
        'render': function (value) {
            if (this.value === this.getCoerce(value)) {
                this.attach();
                this._super();
            } else {
                this.element.empty();
                this.detach();
            }
        }
    });

    var FeeControl = BaseControl.extend({
        'defaults': {
            'tag': 'div'
        }
    }, {
        'create': function () {
            this.model = this.options.model;
            this.render();
        },
        '{model.fee} change': function () {

        }
    });

    var StateLinkControl = BaseControl.extend({
        'defaults': {
            'tag': 'a'
        }
    }, {
        'create': function () {
            this.name  = this.element.attr('name');
            this.clean = this.element.attr('clean');
            this.value = this.element.attr('value');
            this.state = this.options.model.attr('state');
            this.activate(this.state.attr(this.name));
            this.render();
        },
        '{model.state} change': function (self, ev, name, type, value) {
            if (this.name === name) {
                this.activate(value);
            }
        },
        'activate': function (value) {
            if (this.element === null) return;
            if (this.value === value) {
                this.element.addClass('f-active');
            } else {
                this.element.removeClass('f-active');
            }
        },
        'click': function () {
            if(this.clean) this.cleanUrl();
            this.state.attr(this.name, this.value);
        },
        'cleanUrl': function(){
            history.replaceState({}, '','?'+param({widget_id:getQueryParam('widget_id')}));
        }
    });

    var VerifyCodeControl = FieldControl.extend({
        'defaults': {
            'attributes': {
                'name': 'code'
            }
        }
    }, {});

    var PhoneControl = FieldControl.extend({
        'defaults': {
            'attributes': {
                'i18n-placeholder': '+380',
                'i18n-label': 'Phone number',
                'type': 'tel',
                'clean': 'true',
                'autocomplete': 'phone',
                'name': 'receiver_phone'
            },
            'validation': {
                'phone': true
            }
        }
    }, {
        '{model.form} change': function (self, ev, name) {
            if( name === 'send_sms' ){
                this.clearError();
                this.validate();
                this.showError();
            }
        }
    });



    can.view.tag('f-app', function (el, data) {
        new AppControl(el, data);
    });

    can.view.tag('f-state', function (el, data) {
        new StateControl(el, data);
    });

    can.view.tag('f-state-link', function (el, data) {
        new StateLinkControl(el, data);
    });

    can.view.tag('f-input', function (el, data) {
        new FieldControl(el, data);
    });

    can.view.tag('f-form', function (el, data) {
        new FormControl(el, data);
    });

    can.view.tag('f-form-receipt', function (el, data) {
        new FormReceiptControl(el, data);
    });

    can.view.tag('f-form-receive', function (el, data) {
        new FormReceiveControl(el, data);
    });



    can.view.tag('f-card-number', function (el, data) {
        new CardNumberControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'Card number',
                'i18n-label': 'Card number',
                'type': 'tel',
                'autocomplete': 'cc-number',
                'required': 'true',
                'name': 'card_number'
            },
            'validation': {
                'required': true,
                'cc_number': true
            }
        });
    });

    can.view.tag('f-expiry-date', function (el, data) {
        var info   = data.scope.attr('info');
        new ExpiryDateControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'MM / YY',
                'i18n-label': 'Expiry date',
                'type': 'tel',
                'maxlength':'7',
                'autocomplete': 'cc-exp',
                'name': 'expiry_date'
            },
            'validation': {
                'required': true,
                'cc_date': {
                    'strict': info.attr('validate_expdate')
                }
            }
        });
    });

    can.view.tag('f-cvv', function (el, data) {
        new CvcControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'CVV2',
                'i18n-label': 'CVV2',
                'i18n-info': 'CVV2 - bla bla bla',
                'type': 'tel',
                'autocomplete': 'cc-csc',
                'maxlength': '3',
                'name': 'cvv2'
            },
            'validation': {
                'required': true,
                'cc_cvc': true
            }
        });
    });

    can.view.tag('f-email', function (el, data) {
        new FieldControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'Email',
                'i18n-label': 'Email',
                'type': 'email',
                'autocomplete': 'email',
                'name': 'email'
            },
            'validation': {
                'required': true,
                'email': {
                    'message':'Incorrect email'
                }
            }
        });
    });

    can.view.tag('f-expiry-year', function (el, data) {
        new FieldControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'YY',
                'i18n-label': 'YY',
                'type': 'tel',
                'autocomplete': 'cc-exp-year',
                'maxlength': '2',
                'name': 'expiry_year'
            }
        });
    });

    can.view.tag('f-expiry-month', function (el, data) {
        new FieldControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'MM',
                'i18n-label': 'MM',
                'type': 'tel',
                'name': 'expiry_month',
                'autocomplete': 'cc-exp-month',
                'maxlength': '4'
            }
        });
    });

    can.view.tag('f-receiver-card-number', function (el, data) {
        new CardNumberControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'Card number',
                'i18n-label': 'Card number',
                'type': 'tel',
                'clean': 'true',
                'name': 'receiver_card_number',
                'autocomplete': 'cc-number'
            },
            'validation': {
                'required': true,
                'cc_number': true
            }
        });
    });

    can.view.tag('f-receiver-code', function (el, data) {
        new FieldControl(el, data, {
            'attributes': {
                'type': 'hidden',
                'value':'true',
                'clean': 'true',
                'name': 'send_by_code'
            },
            'validation': {
                'required': true
            }
        });
    });

    can.view.tag('f-sender-email', function (el, data) {
        new FieldControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'Email',
                'i18n-label': 'Email',
                'type': 'email',
                'clean': 'true',
                'autocomplete': 'email',
                'name': 'sender_email'
            },
            'validation': {
                'required': true,
                'email': {
                    'message':'Incorrect email'
                }
            }
        });
    });

    can.view.tag('f-receiver-email', function (el, data) {
        new FieldControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'Email',
                'i18n-label': 'Email',
                'type': 'email',
                'clean': 'true',
                'autocomplete': 'email',
                'name': 'receiver_email'
            },
            'validation': {
                'required': true,
                'email': {
                    'message':'Incorrect email'
                }
            }
        });
    });

    can.view.tag('f-receiver-phone', function (el, data) {
        new PhoneControl(el,data,{
            'attributes': {
                'i18n-placeholder': '+380',
                'i18n-label': 'Phone number',
                'type': 'tel',
                'clean': 'true',
                'autocomplete': 'phone',
                'name': 'receiver_phone'
            },
            'validation': {
                'phone': true
            }
        });
    });

    can.view.tag('f-send-sms', function (el, data) {
        new SendSmsControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'Notify receiver over SMS',
                'i18n-label': 'Notify receiver over SMS',
                'type': 'checkbox',
                'autocomplete': 'phone',
                'value': true,
                'name': 'send_sms'
            }
        });
    });

    can.view.tag('f-receiver-fee', function (el, data) {
        new ReceiverFeeControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'Receiver fee',
                'i18n-label': 'Receiver fee',
                'type': 'checkbox',
                'autocomplete': 'phone',
                'value': true,
                'name': 'receiver_pays_fee'
            }
        });
    });

    can.view.tag('f-fee', function (el, data) {
        new FeeControl(el, data);
    });

    can.view.tag('f-amount', function (el, data) {
        var info   = data.scope.attr('info');
        var order  = data.scope.attr('order');
        var state  = data.scope.attr('state');
        var minamount = info.attr('min_amount');
        var maxamount = info.attr('max_amount');
        var maxlength = String(maxamount).length || 3;
        if(order.attr('receiver_amount') && state.is('view','receive')){
            maxamount = order.attr('receiver_amount');
        }
        new AmountControl(el, data, {
            'attributes': {
                'i18n-placeholder': [minamount,maxamount].join('-'),
                'i18n-label': 'Transfer amount',
                'type': 'tel',
                'maxlength': maxlength ,
                'autocomplete': 'amount',
                'name': 'amount'
            },
            'validation': {
                'required': true,
                'amount':{
                    'min':minamount,
                    'max':maxamount
                }
            }
        });
    });

    can.view.tag('f-verify-code', function (el, data) {
        new VerifyCodeControl(el, data, {
            'attributes': {
                'i18n-placeholder': 'XXXXXX',
                'i18n-label': 'Please enter verification code',
                'type': 'tel',
                'autocomplete': 'off',
                'maxlength': '6',
                'name': 'verify_code'
            }
        });
    });

    can.view.tag('f-transfer-code', function (el, data) {
        var form  = data.scope.attr('form');
        var state  = data.scope.attr('state');
        form.on('transfer_code',function(event,value){
            value = String(value || '').split(',');
            state.attr('show-receive-amount',value.length === 1);
        });
        new FieldControl(el, data, {
            'attributes': {
                'name': 'transfer_code',
                'i18n-label':'Code',
                'i18n-placeholder': '###'
            },
            'validation': {
                'required': true,
                'code': true
            }
        });
    });


    can.view.tag('f-currency', function (el, data) {
        new FieldControl(el, data, {
            'attributes': {
                'i18n-label': 'Currency',
                'type': 'text',
                'name': 'currency',
                'readonly': 'true',
                'tabindex': '-1'
            }
        });
    });

    can.view.tag('f-custom-field', function (el, data) {
        var name = data.scope.attr('name');
        var type = data.scope.attr('type');
        var value = data.scope.attr('value');
        var scope = el.getAttribute('scope');
        new FieldControl(el, data, {
            'attributes': {
                'type': type,
                'value': value || '',
                'name': [scope, name].join('.'),
                'i18n-label': [name, 'label'].join('_'),
                'i18n-placeholder': [name, 'placeholder'].join('_')
            }
        });
    });


    can.view.tag('f-input', function (el, data) {
        new FieldControl(el, data, {});
    });

    can.view.tag('f-submit-button', function (el, data) {
        new ButtonControl(el, data, {});
    });

    can.view.tag('f-include', function (el, data) {
        var name = ['inc', el.getAttribute('template')].join('/');
        el.parentNode.replaceChild(can.template(name, data.scope, data.options), el);
    });


    can.view.attr(/data\-f\-\w+/, function (el, data) {
        var attribute = data.attributeName.replace('data-f-','');
        return true;
    });

})(window['can']);


(function(can){
    can.injectStyles = function(css){
        var style = document.createElement("style");
            style.type = 'text/css';
        var append = function (data) {
            if (style.styleSheet && !style.sheet) {
                style.styleSheet.cssText = data;
            } else {
                try {
                    style.appendChild(document.createTextNode(data));
                } catch (e) {
                    style.innerHTML = data;
                }
            }
        };
        append(css);
        document.getElementsByTagName('html')[0].appendChild(style);
    };
})(window['can']);

(function (can) {
    var app = new Router();
    app.matcher = function (route) {
        return hasQueryParams(route.name);
    };
    app.before(function (req, res, next) {
        res.attr('wrapper', can.$('body'));
        res.attr('model', ViewModel.getInstance());
        req.attr('query', getQueryString());
        next();
    });
    app.before(function (req, res, next) {
        i18n.load( i18n.getUserLanguage() ).then(next)
    });
    app.use('widget_id').then(function (req, res, next) {
        res.attr('model').getWidgetInfo().then(next);
    }).then(function(req,res,next){
        can.injectStyles(res.attr('model.info.custom_css'));
        next();
    }).then(function (req, res, next) {
        can.view.load(res.attr('model.info.template')).then(next);
    }).then(function (req, res, next) {
        res.attr('model').getCustomFields().then(next);
    });

    app.use('order_id').then(function (req, res, next){
        res.attr('model').getOrderStatus(req.attr('query')).then(next);
    });

    app.route('widget_id').then(function (req, res) {
        res.attr('wrapper').html(can.template('index', res.attr('model')));
    });

    app.listen(function (callback) {
        callback();
    });




})(window['can']);
